import { NextPage } from 'next';
import { GetServerSideProps } from 'next';
import PodcastsDetail from '@/components/screens/podcasts-detail/PodcastsDetail';
import { API_URL } from '@/helpers/variables';
import { IPodcastsDetailData } from '@/interfaces/podcastsDetail.interface';
import { IReviews } from '@/interfaces/reviews.interface';

interface IBookDetailPage {
  book: IPodcastsDetailData;
  reviews: IReviews;
}

const PodcastsDetailPage: NextPage<IBookDetailPage> = ({ book, reviews }) => {
  return <PodcastsDetail book={book} reviews={reviews} />;
};

export const getServerSideProps: GetServerSideProps = async (context) => {
  const { id } = context.query;

  const [bookRes, reviewsRes] = await Promise.all([fetch(`${API_URL}satellite/podcast/podcast/${id}`), fetch(`${API_URL}satellite/reviews/?book_id=${id}&page=1&page_size=5`)]);

  if (!bookRes.ok) {
    console.table(`Error ${bookRes.status}. Api: ${bookRes.url}`);
    return {
      notFound: true,
    };
  }

  const [book, reviews] = await Promise.all([bookRes.json(), reviewsRes.json()]);

  // Check Fetched Data Error
  if (!book.id) {
    return {
      notFound: true,
    };
  }

  return { props: { book, reviews } };
};

export default PodcastsDetailPage;
